export const ICON_SIZES = {
	xxSmall: 14,
	xSmall: 16,
	small: 18,
	medium: 20,
	large: 24,
	xLarge: 32,
	xxLarge: 40,
} as const;
